import React, { useState, useEffect} from 'react';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import api from '../conexao.js';
import { format } from 'date-fns';
import logOut from '../logOut';
import HorariosAgenda from './horariosAgenda.js';



export default function Agenda(){

    const [data, setData] = useState(new Date());
    const [codMed, setCodMed] = useState();

    const [medicos, setMedicos] = useState([]); 

    const [dateRouter, setDateRouter] = useState('');
    const [disableBtnAgenda, setDisableBtnAgenda] = useState(true);
    const [click, setClick] = useState(true)
    let cMed;
    let tokin = localStorage.getItem('token')
    const [modalMSG, setModalMSG] = useState(false);
    const [MSG, setMSG] = useState();
    const [modalEncaixe, setModalEncaixe] = useState(false);
    const [horaEncaixe, setHoraEncaixe] = useState();
    // const [encaixe, setEncaixe] = useState("");
    const [encaixe, setEncaixe] = useState();
    const [modalBuscaAgenda, setModalBuscaAgenda] = useState(false)
    const [paciente, setPaciente] = useState();
    const [listaPacAgenda, setListaPacAgenda] = useState();
    const [nomePacienteBusca, setNomePacienteBusca] = useState('');
    const [pacientesEncontrados, setPacientesEncontrados] = useState([]);

useEffect( () => {   
    const buscaMedico = async () => { 
            await api.get('/medico',{
                params: {
                    nome: '%'
                }
            }).then( result => {
                setCodMed(result.data[0].CODIGO)    
                setMedicos(result.data)     
                cMed = result.data[0].CODIGO
            }).catch(
                
                (error) => {
                    setMSG(logOut(error))
                    setModalMSG(true)
                }
                
                )
        }

        buscaMedico(); 
       
        // console.log(click)

},[]);   



function handleClicaDia(){
    
    setData()
    setClick(false)
    setEncaixe()
    
}

function atualiza()
{
    setClick(false)
    setClick(true)  

}

function onChange(date){
    setData(date);
    setClick(true)
}        

function trocaMedico(cod){
    var dt = new Date();
    setData(dt)
    setCodMed(cod)
    setClick(true)
}

function fEncaixe(hora) {
    
   
   let x = {CODIGO : 0,
        COD_MEDICO : 0,
        COD_PACIENTE : 0,
        COD_SITUACAO : 0,
        COD_STATUS : 0,
        DATA : data,
        HORA : hora,
        Paciente: {CODIGO: 0, NOME: "", 
        CEL: "",
        PLANO: ""},
        Procedimento: {DESCRICAO: ""},
        Status: {DESCRICAO: ""},
        VALOR: 0, 
        ENCAIXE: 1                                     
    }
    setEncaixe(x);
    // console.log(click)
    setModalEncaixe(false)
    setClick(false)
    

}

function fModalEnxaixe(){
    if (modalEncaixe) {
        setModalEncaixe(false)} else {
            setHoraEncaixe()
            setModalEncaixe(true)}
}

const formataMesAnoCalendar = (locale, date) => {
    return date.toLocaleString(locale, {month: 'short', year: 'numeric' })

}

function formataCelular(celular) {
    if (!celular) return 'N/A';
    const cel = celular.replace(/\D/g, '');
    if (cel.length === 11) {
        return `(${cel.slice(0,2)})${cel.slice(2,7)}-${cel.slice(7)}`;
    }
    return celular;
}

function ModalBuscaPac(){
    setModalBuscaAgenda(true)
}

async function buscaPac(nome){
    await api.get('/paciente', { 
          params: {           //BUSCA POR PARAMETRO ? NOME
            nome: nome
            //banco: localStorage.getItem('banco')
          }}).then( (result) => {
          setPacientesEncontrados(result.data) // joga a resposta em pacientesEncontrados
        //   console.log(result.data)
       }).catch(
        (error) => {
            setMSG(logOut(error))
            setModalMSG(true)
        }
       )
}

function selecionaPaciente(pacienteSelecionado){
    setPaciente(pacienteSelecionado);
    setPacientesEncontrados([]);
    setNomePacienteBusca(`${pacienteSelecionado.NOME} - ${new Date(pacienteSelecionado.DATA_NASC).toLocaleDateString('pt-BR')}`);
    buscaPacAgenda(pacienteSelecionado.CODIGO);
}

async function buscaPacAgenda(codPac){
    await api.get('/agendapac', {
        params:{
            codpac: codPac
        }
    }).then(
        (result) => {
            setListaPacAgenda(result.data)
        }
    ).catch(
        (error) => {
            setMSG(logOut(error))
            setModalMSG(true)
        }
    )
}



    return (
        <div className="container-fluid  table-hover table-responsive" style={{backgroundColor: "#e6eff5"}}>
            
            <div className="row">
                <div className="col-md-2">   
                    <br />
                        Selecione o Médico:     
                        <Form.Select  size="sm" as="select" value={codMed} onChange={e => trocaMedico(e.target.value)}>
                            {medicos.map( med => (
                                <option value={med.CODIGO}>{med.NOME}</option>
                            ))}
                        </Form.Select> 

                </div>
                
                <div className="col-md-8" 
                // style={{align:"right"}}
                >
                    <br />
                    <br />
                    <center style={{fontSize:"20px", fontFamily:"sans-serif" }}>{format(data, 'dd/MM/yyyy')}</center>    
                </div>                              
                                                       
            </div>
            <div className="row">
                <div className="col-md-2">
                    <div > 
                        <br />
                        <Calendar                            
                            className="react-calendar"
                            value={data}
                            onChange={onChange}
                            onClickDay={handleClicaDia}  
                            formatMonthYear={formataMesAnoCalendar}  
                            prev2Label={null}
                            next2Label={null}                    
                        />               
           
                    </div>
                    <div style={{marginTop: "10px"}}>
                    <Button 
                             onClick={() => fModalEnxaixe()}>
                                Encaixe
                        </Button>
                    <Button variant="info"
                             onClick={() => ModalBuscaPac()}>
                                Buscar na Agenda
                        </Button>
                    </div>

                </div>
                <div className="col-md-10" >
                <br />
                <Table>
                    <thead>
                        <tr>
                            <th scope="col">Hora </th>
                            <th scope="col">Nome</th>
                            <th scope="col">Status</th>
                            <th scope="col">Procedimento</th>
                            <th scope="col">Plano</th>
                            <th scope="col">Celular</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody> 
                              
   
                                {/* RENDERIZAÇAO CONDICIONAL PARA O ENCAIXE E O CLICK  NO DIA,
                                QUANDO TEM ENCAIXE NAO TEM CLICK, AI ELE TRAZ AS MSM INF.S DO CLICK
                                POREM COM ENCAIXE, QUE É APAGADO SE NAO FOR AGENDADO. */}

                        { encaixe && <HorariosAgenda dia={data} codigoMed={codMed} click={atualiza} pEncaixe={encaixe} /> } 
                        { click && <HorariosAgenda dia={data} codigoMed={codMed} click={atualiza} 
                        pEncaixe={encaixe} 
                        /> } 
           
                    </tbody>
               </Table>
                </div>


            </div>

            <br />
                        
            <Modal show={modalMSG}>
                <Modal.Header> 
                    <h3>{MSG}</h3>
                </Modal.Header> 
                <Modal.Footer>
                    <Button variant="info" onClick={() => setModalMSG(false)}>Ok</Button>
                </Modal.Footer>
            </Modal>  
            <Modal show={modalEncaixe}>
                <Modal.Header> 
                    <h3>Encaixe de Horários</h3>
                </Modal.Header> 
                
                <Modal.Body>
                Horário:
                    <Form.Control 
                        onChange={(e) => setHoraEncaixe(e.target.value)}  
                        type="time"
                        step="2"
                        value={horaEncaixe}
                        />               
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="info" onClick={() => fEncaixe(horaEncaixe) }>Gravar</Button>
                    <Button variant="danger" onClick={() => fModalEnxaixe()}>Cancelar</Button>
                </Modal.Footer>

            </Modal> 

            <Modal show={modalBuscaAgenda} size="lg" centered onHide={() => {setModalBuscaAgenda(false); setNomePacienteBusca(''); setPaciente(null); setListaPacAgenda(null); setPacientesEncontrados([]);}}>
                <Modal.Header> 
                    <h3>Busque o paciente:</h3>
                </Modal.Header> 
                
                <Modal.Body>
                    Paciente
                    <Form.Control 
                      type='text'
                      value={nomePacienteBusca}
                      style={{textTransform: 'uppercase'}}
                      onChange={(e) => {
                        setNomePacienteBusca(e.target.value.toUpperCase());
                        if(e.target.value.length >= 5) {
                          buscaPac(e.target.value.toUpperCase());
                        } else {
                          setPacientesEncontrados([]);
                        }
                      }}
                        />
                    
                    {pacientesEncontrados.length > 0 && (
                        <div style={{marginTop: '10px', maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc', borderRadius: '4px'}}>
                            {pacientesEncontrados.map((pac, index) => (
                                <div 
                                    key={index}
                                    onClick={() => selecionaPaciente(pac)}
                                    style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        borderBottom: '1px solid #eee',
                                        backgroundColor: '#fff'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#fff'}
                                >
                                    {pac.NOME} - {new Date(pac.DATA_NASC).toLocaleDateString('pt-BR')}
                                </div>
                            ))}
                        </div>
                    )}
                    
                    {listaPacAgenda && listaPacAgenda.length > 0 && (
                        <div style={{marginTop: '20px'}}>
                            <h6>Agendamentos do Paciente:</h6>
                            <div style={{maxHeight: '300px', overflowY: 'auto'}} className="table-responsive">
                                <Table striped bordered hover size="sm" responsive>
                                    <thead>
                                        <tr>
                                            <th>DATA</th>
                                            <th>HORA</th>
                                            <th>STATUS</th>
                                            <th>PROCEDIMENTO</th>
                                            <th>PLANO</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listaPacAgenda.map((agenda, index) => (
                                            <tr key={index}>
                                                <td>{new Date(agenda.DATA).toLocaleDateString('pt-BR')}</td>
                                                <td>{agenda.HORA}</td>
                                                <td>{agenda.descStatus || 'N/A'}</td>
                                                <td>{agenda.descSituacao || 'N/A'}</td>
                                                <td>{agenda.PLANO || 'N/A'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    )}               
                </Modal.Body>
                <Modal.Footer>
                      <Button variant="danger" onClick={() => {setModalBuscaAgenda(false); setNomePacienteBusca(''); setPaciente(null); setListaPacAgenda(null); setPacientesEncontrados([]);}} >Sair</Button>
                </Modal.Footer>

            </Modal> 
           
         </div>
        
    );
}

